module.exports = __webpack_public_path__ + "img/직접매칭.7e309c46.png";